import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import { BigBreadcrumbs, WidgetGrid } from '../../../components';
import { Modal } from 'react-bootstrap';
import SpecialProgramForm from '../components/SpecialProgramForm';
import Dropzone from 'react-dropzone';
import classNames from 'classnames';
import { humanFileSize } from '../../../components/utils/format';
import OutreachEditForm from '../../administration/components/OutreachEditForm';
import { requestOutreaches, requestOutreachDetails, updateOutreach, requestOutreachTypes, deleteOutreach } from '../../../store/outreach/OutreachActions';
import {
  requestPatient,
  requestMedicalClaims,
  requestRxClaims,
  requestClaimsHistory,
  requestPatientEncounters,
  requestHealthProfile,
  requestSurveyData,
  requestInvitePatient,
  requestAllSpecialPrograms,
  requestPatientDocuments,
  previewPatientDocumentFile,
  uploadPatientDocuments,
  deletePatientDocument,
  requestPatientSpecialProgramsByPatientId,
  requestAssignedPatientSpecialProgramsByPatientId,
  updatePatientToSpecialProgram,
  unassignPatientSpecialProgram
} from '../../../store/patients/PatientsActions';
import {
  requestPatientComments,
  addPatientComment,
  updatePatientComment,
  deletePatientComment,
} from '../../../store/comments/CommentsActions';
import { requestUserInfo } from '../../../store/current-user/CurrentUserActions';
import { isSuperAdmin, isExecutive, isMakoAdmin, isMakoUser } from '../../../store/current-user/CurrentUserSelectors';
import { Link } from 'react-router';
import ReactTable from 'react-table';
import Moment from '../../../components/utils/Moment';
import Pagination from '../../../components/common/Pagination';
import Comments from '../../../routes/administration/components/Comments';
import PatientQueryKno2 from '../components/PatientQueryKno2';
import AllActivity from '../components/AllActivity';
import CommentForm from '../../../routes/administration/components/CommentForm';
import {
  requestPatientEscalations,
  deletePatientEscalation,
} from '../../../store/escalation-manager/EscalationManagerActions';
import { requestPatientContacts } from '../../../store/contact-manager/ContactManagerActions';
import { requestKno2PatientDiscovery } from '../../../store/query-kno2-manager/QueryKno2ManagerActions';
import * as moment from 'moment';
import { hashHistory } from 'react-router';
import { toast } from 'react-toastify';
import { hostTitle } from '../../../config/ui';
import FileViewer from 'react-file-viewer';

class PatientProfile extends React.Component {

  constructor() {
    super();
    this.disposal = null;

    this.state = {
      showModal: false,
      showPreview: false,
      files: [],
      showUpload: false,
      title: '',
      description: '',
      fileName: null,
      fileType: null,
      showOutreachModal: false,
      showKno2Orgs: false
    };
  }

  componentWillMount() {
    this.props.getPatient(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getPatientComments(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getEncounters(this.props.params.masterPatientId, 0, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getMedicalClaims(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getRxClaims(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getHistory(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
      from: null,
    });
    this.props.getCurrentUser();
    this.props.getHealthProfile(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getSurveyData(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getEscalations(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getContacts(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getAllSpecialPrograms({
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getPatientSpecialProgramsByPatientId(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getAssignedPatientSpecialProgramsByPatientId(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.props.getOutreaches({
      masterId: this.props.params.masterPatientId,
      tenantId: this.props.user.queryParams.tenantId,
      order: 'desc date'
    });
    this.props.getPatientDocuments(this.props.params.masterPatientId, {
      tenantId: this.props.user.queryParams.tenantId,
    });
    this.commentClick = this.commentClick.bind(this);
  }

  queryKno2 = () => {
    this.setState({ showKno2Orgs: true });
  };

  fetchQueryKno2 = () => {
    var dob = moment(this.props.data.patient[0].dob).format('MMDDYYYY');
    return this.props.getKno2PatientDiscovery({
      tenantId: this.props.user.queryParams.tenantId,
      firstName: this.props.data.patient[0].firstName,
      lastName: this.props.data.patient[0].lastName,
      birthDate: dob,
      gender: this.props.data.patient[0].gender,
      zipCode: this.props.data.patient[0].addressZip
    });
  };

  formatPhoneNumber(phoneNumberString) {
  var cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    return '(' + match[1] + ') ' + match[2] + '-' + match[3];
  }
  return null;
}

  showSpecialProgramModal() {
    this.setState({ showModal: true });
  }

  closeSpecialProgramModal() {
    this.setState({ showModal: false });
  }

  previewFile(patientId, documentId, filename) {
    this.props
      .previewPatientDocumentFile(
        patientId,
        documentId,
        {
          tenantId: this.props.user.queryParams.tenantId,
        },
        filename,
      )
      .then((response) => {
        const blob = response.payload;
        var type = filename.substring(
          filename.lastIndexOf('.') + 1,
          filename.length,
        );
        this.setState({ fileName: URL.createObjectURL(blob) });
        this.setState({ fileType: type });
        this.setState({ showPreview: true });
      });
  }

  closePreview() {
    this.setState({ showPreview: false });
  }

  onProgramSubmit = (program) => {
    this.props
      .updateSpecialProgram(this.props.params.masterPatientId, program, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        this.setState({ showModal: false });
        if (result.error) {
          toast.error(result.payload.response.error.message);
        } else {
          toast.success('Program saved.');
          this.props.getPatientSpecialProgramsByPatientId(
            this.props.params.masterPatientId,
            {
              tenantId: this.props.user.queryParams.tenantId,
            },
          );
          this.props.getAssignedPatientSpecialProgramsByPatientId(
            this.props.params.masterPatientId,
            {
              tenantId: this.props.user.queryParams.tenantId,
            },
          );
        }
      });
  };

  unassignSpecialProgram = (id) => {
    this.props
      .unassignPatientSpecialProgram(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error(result.payload.response.error.message);
        } else {
          toast.success('Program unassigned.');
          this.props.getPatientSpecialProgramsByPatientId(
            this.props.params.masterPatientId,
            {
              tenantId: this.props.user.queryParams.tenantId,
            },
          );
          this.props.getAssignedPatientSpecialProgramsByPatientId(
            this.props.params.masterPatientId,
            {
              tenantId: this.props.user.queryParams.tenantId,
            },
          );
        }
      });
  };

  searchOutreachTypes = () => {
    return this.props
      .getOutreachTypes({
        tenantId: this.props.tenantId
      })
      .then((result) => {
        const options = [];
        if (result.payload.data) {
          result.payload.data.forEach((item) =>
            options.push({ id: item.id, name: item.name }),
          );
        }
        return options;
      });
  };

  getOutreach = (id) => {
    this.props.getOutreach(id, {
      tenantId: this.props.tenantId,
    });
    this.setState({ showOutreachModal: true });
  };

  deleteOutreach = (id) => {
    this.props
      .deleteOutreach(id, {
        tenantId: this.props.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        }
        else {
          toast.success('Outreach Deleted.');
          this.props.getOutreaches({
            masterId: this.props.params.masterPatientId,
            tenantId: this.props.user.queryParams.tenantId,
            order: 'desc date'
          })
        }
      });
  };

  closeModal() {
    this.setState({ showOutreachModal: false });
  }

  updateOutreach = (values) => {
      this.props
        .updateOutreach(values, {
          tenantId: this.props.user.queryParams.tenantId
        })
        .then((result) => {
          if (result.error) {
            toast.error('Something went wrong. Try again later.');
          }
          else {
            toast.success('Outreach Saved.');
            this.props.getOutreaches({
              masterId: this.props.params.masterPatientId,
              tenantId: this.props.user.queryParams.tenantId,
              order: 'desc date'
            })
          }
        });
        this.setState({
          showOutreachModal: false,
        });
  }
  
  onSubmit = (parentId, message) => {
    this.props
      .addMessage(message, {
        tenantId: this.props.user.queryParams.tenantId,
        parentId: parentId,
        masterPatientId: this.props.params.masterPatientId,
      })
      .then(() =>
        this.props.getPatientComments(this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onUpdateSubmit = (id, message) => {
    this.props
      .updateMessage(id, message, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getPatientComments(this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  onDeleteSubmit = (id) => {
    this.props
      .deleteMessage(id, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getPatientComments(this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  getActivityData(patient) {
    let parentComments = [];
    if (
      this.props.comments &&
      this.props.comments.data &&
      this.props.comments.data.list
    ) {
      parentComments = this.props.comments.data.list.map((el) => ({
        type: 'C',
        date: el.createdAt,
        source: el,
      }));
    }

    let rxClaims = [];
    if (
      this.props.data &&
      this.props.data.rxClaims &&
      this.props.data.rxClaims.list
    ) {
      rxClaims = this.props.data.rxClaims.list.map((el) => ({
        type: 'RC',
        date: el.filledAt,
        source: el,
      }));
    }

    let medicalClaims = [];
    if (
      this.props.data &&
      this.props.data.medicalClaims &&
      this.props.data.medicalClaims.list
    ) {
      medicalClaims = this.props.data.medicalClaims.list.map((el) => ({
        type: 'MC',
        date: el.dateOfServiceStartDate,
        source: el,
      }));
    }

    let specialPrograms = [];
    if (this.props.data.patientSpecialPrograms) {
      specialPrograms = this.props.data.patientSpecialPrograms.map((el) => ({
        type: 'SP',
        date: (el.unAssignedAt === null) ? el.assignedAt : el.unAssignedAt,
        name: (el.unAssignedAt === null) ? el.assignedByEmail : el.unAssignedByEmail,
        source: el,
      }));
    }

    let newEncounters = [];
    if (
      this.props.encounters[patient[0] && patient[0].masterPatientId] &&
      this.props.encounters[patient[0] && patient[0].masterPatientId].total > 0
    ) {
      newEncounters = this.props.encounters[
        patient[0] && patient[0].masterPatientId
      ].list.map((el) => ({ type: 'E', date: el.dateOfService, source: el }));
    }

    let allActivities = [];
    allActivities = [
      ...newEncounters,
      ...rxClaims,
      ...medicalClaims,
      ...parentComments,
      ...specialPrograms,
    ];
    allActivities.sort(function (a, b) {
      var dateA = new Date(a.date),
        dateB = new Date(b.date);
      return dateB - dateA;
    });

    return allActivities;
  }

  showEscalationForm = (escalationId, masterPatientId) => {
    hashHistory.push(`/patients/escalation/${escalationId}/${masterPatientId}`);
  };

  deleteEscalation = (escalationId) => {
    this.props
      .deletePatientEscalation(escalationId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() =>
        this.props.getEscalations(this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        }),
      );
  };

  commentClick = (e) => {
    if ($(e.target).data('comment')) {
      $('#comments-tab-link').tab('show');
      const comment = $(
        `[data-comment-id="${$(e.target).data('comment')}"] li`,
      );
      comment.effect('highlight', {}, 3000);
      setTimeout(() => comment[0].scrollIntoView(false), 300);
    }
  };

  invitePatient = (masterPatientId) => {
    this.props
      .invitePatient(masterPatientId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then((result) => {
        if (result.error) {
          toast.error('Something went wrong. Try again later.');
        } else {
          toast.success('Patient Invited.');
          $('#invitePatient').hide();
        }
      });
  };

  editPatient = (masterPatientId) => {
    hashHistory.push(`/patients/patient/${masterPatientId}`);
  };

  showContactForm = (contactId, mode, masterPatientId) => {
    hashHistory.push(`/patients/contact/${contactId}/${mode}/${masterPatientId}`);
  };

  onDrop(files) {
    if (this.state.files.length === 0) {
      const filesToAdd = _.difference(files, this.state.files);
      this.setState({ files: this.state.files.concat(filesToAdd) });
    }
  }

  onFileCancel() {
    this.setState({
      files: [],
    });
  }

  showUploadModal() {
    this.setState({ showUpload: true });
  }

  closeUploadModal() {
    this.setState({ showUpload: false });
    this.onFileCancel();
  }

  removeFileFromUploadList(fileName) {
    this.setState({
      files: this.state.files.filter((file) => file.name !== fileName),
    });
  }

  onStartUpload() {
    this.props
      .uploadFiles(
        this.props.params.masterPatientId,
        {
          tenantId: this.props.user.queryParams.tenantId,
          name: this.state.title,
          date: this.state.description
        },
        this.state.files,
      )
      .then((result) => {
        if (result.error) {
          const message = _.get(result, 'payload.response.error.message', null);
          if (message) {
            toast.error(message);
          } else {
            toast.error('Something went wrong. Try again later.');
          }
        } else {
          toast.success('Files have been uploaded.');
          this.setState({ showUpload: false, files: [] });
          this.props.getPatientDocuments(this.props.params.masterPatientId, {
            tenantId: this.props.user.queryParams.tenantId,
          });
        }
      });
  }

  handleTitleChange(event) {
    this.setState({ title: event.target.value });
  }

  handleDescriptionChange(event) {
    this.setState({ description: event.target.value });
  }

  deleteDocument = (patientId, documentId) => {
    this.props
      .deletePatientDocument(patientId, documentId, {
        tenantId: this.props.user.queryParams.tenantId,
      })
      .then(() => {
        toast.success('Document deleted.');
        this.props.getPatientDocuments(this.props.params.masterPatientId, {
          tenantId: this.props.user.queryParams.tenantId,
        })
      })
  }

  render() {
    const {
      data: { patient },
      encounters,
      isEncountersLoading,
      data,
      outreach,
      comments,
      documents,
      isDocumentsLoading,
      user,
      healthprofile,
      isHealthProfileLoading,
      isFilesUploading,
      escalations,
      contacts,
      isExecutive
    } = this.props;

    const {
      isMakoAdmin,
      isMakoUser
    } = this.props;

    const filterCaseInsensitive = (filter, row) => {
      const id = filter.pivotId || filter.id;
      const rowId = isNaN(row[id]) ? row[id].toLowerCase() : row[id];
      const filterValue = isNaN(filter.value)
        ? filter.value.toLowerCase()
        : filter.value;
      return row[id] !== undefined && row[id] !== null
        ? String(rowId).includes(filterValue)
        : true;
    };

    //var phoneNumber = patient[0] && patient[0].phoneNumber.toString();
    //const phone = (phoneNumber === undefined) ? '' : '(' + phoneNumber.substring(0, 3) + ') ' + phoneNumber.substring(3, 6) + '-' + phoneNumber.substring(6, 10);

    const outreaches = outreach.data;
    var isManual = patient[0] && patient[0].isManual;
    const makoMode = isMakoAdmin || isMakoUser;

    const filesToUpload = this.state.files.map((file) => (
      <li className="list-group-item" key={file.name}>
        <span className="filename">{file.name}</span>
        <a
          className="action btn btn-xs btn-danger"
          onClick={() => this.removeFileFromUploadList(file.name)}
        >
          <i className="fa fa-close" />
        </a>
        <span className="badge">{humanFileSize(file.size)} bytes</span>
        <br />
        <input className="form-control" placeholder="Name" onChange={this.handleTitleChange.bind(this)}></input>
        <input className="form-control" placeholder="Document Date" onChange={this.handleDescriptionChange.bind(this)}></input>
      </li>
    ));

    const acceptedFiles =
      'image/jpeg, image/png, image/gif, image/x-icon, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.oasis.opendocument.text, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/x-photoshop, audio/mpeg, audio/x-m4a, application/ogg, video/mp4, video/mpeg4, video/x-m4v, video/quicktime, video/x-ms-wmv, video/avi, video/mpeg, video/ogg, video/3gpp, video/3gpp2';

    return (
      <div id="content">
        {patient[0] && patient[0].masterPatientId && (
          <Helmet
            title={`${patient[0] && patient[0].masterPatientId} – ${hostTitle()}`}
          />
        )}
        <BigBreadcrumbs
          items={[
            'Practice Management',
            { title: 'Patients', route: '/patients' },
            'Patient Profile',
          ]}
          icon="fa fa-fw fa-hospital-o"
          className=""
        />

        <WidgetGrid>
          <div className="row padding-top-15">
            <div className="col-sm-12">
              <div className="well well-sm">
                <div className="row">
                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div className="well well-light well-sm no-margin no-padding">
                      <div className="row">
                        <div className="col-sm-3 profile-pic">
                          <img
                            src="assets/img/avatars/sunny-big.png"
                            alt="demo user"
                          />
                          <div className="padding-10">
                            <h4 className="font-md">
                              <strong>
                                {patient[0] &&
                                  patient[0].concurrentRiskScore &&
                                  `${
                                    patient[0] &&
                                    patient[0].concurrentRiskScore.toFixed(2)
                                  }%`}
                              </strong>
                              <br />
                              <small>Concurrent Risk</small>
                            </h4>
                            <br />
                            <h4 className="font-md">
                              <strong>
                                {patient[0] &&
                                  patient[0].prospectiveRiskScore &&
                                  `${
                                    patient[0] &&
                                    patient[0].prospectiveRiskScore.toFixed(2)
                                  }%`}
                              </strong>
                              <br />
                              <small>Prospective Risk</small>
                            </h4>
                          </div>
                        </div>
                        <div className="col-sm-6">
                          <h1>
                            <span className="semi-bold">
                              {patient[0] && patient[0].fullName}
                            </span>
                            <br />
                            <small>
                              {' '}
                              {patient[0] && patient[0].employerName}{' '}
                            </small>
                          </h1>
                          <span className="semi-bold">
                            {' '}
                            {patient[0] && patient[0].employerCode}{' '}
                          </span>
                          <ul className="list-unstyled">
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-gift"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  <Moment
                                    date={patient[0] && patient[0].dob}
                                    format="MM/DD/YYYY"
                                  />
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-user"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  {patient[0] && patient[0].gender}
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-envelope"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  {patient[0] && patient[0].email}
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-phone"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  Mobile: {patient[0] && this.formatPhoneNumber(patient[0].mobilePhone)}
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-phone"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  Home: {patient[0] && this.formatPhoneNumber(patient[0].homePhoneNumber)}
                                </span>
                              </p>
                            </li>
                            <li>
                              <p className="text-muted">
                                <i className="fa fa-home"></i>&nbsp;&nbsp;
                                <span className="txt-color-darken">
                                  {[
                                    patient[0] && patient[0].addressLine1,
                                    patient[0] && patient[0].addressLine2,
                                    patient[0] && patient[0].addressCity,
                                    patient[0] && patient[0].addressState,
                                    patient[0] && patient[0].addressZip,
                                  ]
                                    .filter((val) => val !== '')
                                    .join(', ')}
                                </span>
                              </p>
                            </li>
                            {patient.length > 0 &&
                              patient.slice(0, 1).map((pat) => (
                                <li key={pat}>
                                  <p className="text-muted">
                                    <span className="txt-color-darken">
                                      Elation Id: {pat.elationId} &nbsp;&nbsp;{' '}
                                    </span>
                                    <br />
                                    <span className="txt-color-darken">
                                      Athena Id: {pat.athenaId} &nbsp;&nbsp;{' '}
                                    </span>
                                    <br />
                                    <i className="fa fa-calendar"></i>
                                    &nbsp;&nbsp;
                                    <span className="txt-color-darken">
                                      Last Appt:
                                      {pat.lastClinicVisit !== null && (
                                        <a
                                          href=""
                                          rel="tooltip"
                                          title=""
                                          data-placement="top"
                                          data-original-title="View Appointment"
                                        >
                                          {' '}
                                          <Moment
                                            date={pat.lastClinicVisit}
                                            format="MM/DD/YYYY HH:mm"
                                          />
                                        </a>
                                      )}
                                      {pat.lastClinicVisit === null && (
                                        <span> Date Not Mentioned</span>
                                      )}
                                    </span>
                                  </p>
                                </li>
                              ))}
                          </ul>
                          <br />
                        </div>
                        <div className="col-sm-3">
                          <button disabled={!(isManual || makoMode)}
                            className="btn btn-primary"
                            onClick={() => this.editPatient(patient[0].masterPatientId)}
                          >
                            EDIT
                          </button>
                        </div>
                        {/*{isSuperAdmin && (*/}
                        {/*  <div className="col-sm-3">*/}
                        {/*    <br />*/}
                        {/*    {patient[0] &&*/}
                        {/*      patient[0].mappingId === null &&*/}
                        {/*      patient[0].email !== 'NA' && (*/}
                        {/*      <button*/}
                        {/*          id="invitePatient"*/}
                        {/*          className="btn btn-primary"*/}
                        {/*          onClick={() =>*/}
                        {/*            this.invitePatient(*/}
                        {/*              patient[0].masterPatientId,*/}
                        {/*            )*/}
                        {/*          }*/}
                        {/*        >*/}
                        {/*          Invite*/}
                        {/*        </button>*/}
                        {/*      )}*/}
                        {/*    {patient[0] &&*/}
                        {/*      patient[0].statusId === 1 &&*/}
                        {/*      patient[0].email !== 'NA' && (*/}
                        {/*        <button*/}
                        {/*          id="invitePatient"*/}
                        {/*          className="btn btn-primary"*/}
                        {/*          onClick={() =>*/}
                        {/*            this.invitePatient(*/}
                        {/*              patient[0].masterPatientId,*/}
                        {/*            )*/}
                        {/*          }*/}
                        {/*        >*/}
                        {/*          Resend Invite*/}
                        {/*        </button>*/}
                        {/*      )}*/}
                        {/*  </div>*/}
                        {/*)}*/}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-sm-12">
                        <hr />
                        <div className="padding-10">
                          <ul className="nav nav-tabs">
                            <li className="active">
                              <a href="#a1" data-toggle="tab">
                                Health Profile
                              </a>
                            </li>
                            <li>
                              <a href="#a2" data-toggle="tab">
                                Surveys
                              </a>
                            </li>
                            <li>
                              <a href="#a3" data-toggle="tab">
                                Membership
                              </a>
                            </li>
                            <li>
                              <a href="#a4" data-toggle="tab">
                                Special Programs
                              </a>
                            </li>
                            <li>
                              <a href="#a5" data-toggle="tab">
                                Escalations
                              </a>
                            </li>
                            <li className="">
                              <a href="#contacts" data-toggle="tab">
                                Contacts
                              </a>
                            </li>
                          </ul>
                          <div className="tab-content padding-top-10">
                            <div className="tab-pane fade in active" id="a1">
                              <div className="row">
                                <div className="col-md-12">
                                  {isHealthProfileLoading && (
                                    <div className="spinner" />
                                  )}
                                  <h3>Allergies</h3>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Name',
                                          accessor: 'name',
                                        },
                                        {
                                          Header: 'Allergen Type',
                                          accessor: 'allergenType',
                                        },
                                        {
                                          Header: 'Reaction',
                                          accessor: 'reaction',
                                        },
                                        {
                                          Header: 'Status',
                                          accessor: 'status',
                                        },
                                        {
                                          Header: 'Creation Time',
                                          accessor: 'creationTime',
                                          Cell: (row) => (
                                            <Moment
                                              date={row.original.creationTime}
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].patientAllergy
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].patientAllergy
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'creationTime',
                                          desc: true,
                                        },
                                        {
                                          id: 'name',
                                          asc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  <h3>Drug Intolerances</h3>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Name',
                                          accessor: 'name',
                                        },
                                        {
                                          Header: 'Allergen Type',
                                          accessor: 'allergenType',
                                        },
                                        {
                                          Header: 'Reaction',
                                          accessor: 'reaction',
                                        },
                                        {
                                          Header: 'Status',
                                          accessor: 'status',
                                        },
                                        {
                                          Header: 'Creation Time',
                                          accessor: 'creationTime',
                                          Cell: (row) => (
                                            <Moment
                                              date={row.original.creationTime}
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].patientDrugIntolerance
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].patientDrugIntolerance
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'creationTime',
                                          desc: true,
                                        },
                                        {
                                          id: 'name',
                                          asc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  <h3>Problem List</h3>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Description',
                                          accessor: 'description',
                                        },
                                        {
                                          Header: 'Start Date',
                                          accessor: 'startDate',
                                          Cell: (row) => (
                                            <Moment
                                              date={row.original.startDate}
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                        {
                                          Header: 'Resolved Date',
                                          id: 'resolvedDate',
                                          accessor: (d) =>
                                            d.resolvedDate && (
                                              <Moment
                                                date={d.resolvedDate}
                                                format="MM/DD/YYYY hh:mm"
                                              />
                                            ),
                                        },
                                        {
                                          Header: 'Status',
                                          accessor: 'status',
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].patientProblem
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].patientProblem
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'status',
                                          asc: true,
                                        },
                                        {
                                          id: 'startDate',
                                          desc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  <h3>History</h3>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Type',
                                          accessor: 'type',
                                        },
                                        {
                                          Header: 'RelationshipType',
                                          accessor: 'relationshipType',
                                        },
                                        {
                                          Header: 'Value',
                                          accessor: 'value',
                                        },
                                        {
                                          Header: 'Creation Time',
                                          accessor: 'creationTime',
                                          Cell: (row) => (
                                            <Moment
                                              date={row.original.creationTime}
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                        {
                                          Header: 'Deletion Time',
                                          id: 'deletionTime',
                                          accessor: (d) =>
                                            d.deletionTime && (
                                              <Moment
                                                date={d.deletionTime}
                                                format="MM/DD/YYYY hh:mm"
                                              />
                                            ),
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].patientHistory
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].patientHistory
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'type',
                                          asc: true,
                                        },
                                        {
                                          id: 'creationTime',
                                          desc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  <h3>Medications</h3>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Start Date',
                                          accessor: 'startDate',
                                          Cell: (row) => (
                                            <Moment
                                              date={row.original.startDate}
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                        {
                                          Header: 'Type',
                                          accessor: 'type',
                                        },
                                        {
                                          Header: 'Medication Type',
                                          accessor: 'medicationType',
                                        },
                                        {
                                          Header: 'Displayed Med Name',
                                          accessor: 'displayedName',
                                        },
                                        {
                                          Header: 'Route',
                                          accessor: 'route',
                                        },
                                        {
                                          Header: 'Strength',
                                          accessor: 'strength',
                                        },
                                        {
                                          Header: 'Form',
                                          accessor: 'form',
                                        },
                                        {
                                          Header: 'Directions',
                                          accessor: 'directions',
                                        },
                                        {
                                          Header: 'Qty',
                                          accessor: 'quantity',
                                        },
                                        {
                                          Header: 'Qty Units',
                                          accessor: 'Units',
                                        },
                                        {
                                          Header: 'AuthRefills',
                                          accessor: 'authRefills',
                                        },
                                        {
                                          Header: 'Origin',
                                          accessor: 'origin',
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].medicationOrder
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].medicationOrder
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'startDate',
                                          desc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  <h3>Other Info</h3>
                                  <h4>Vaccinations</h4>
                                  {healthprofile[
                                    patient[0] && patient[0].masterPatientId
                                  ] && (
                                    <ReactTable
                                      columns={[
                                        {
                                          Header: 'Elation Id',
                                          accessor: 'patientId',
                                        },
                                        {
                                          Header: 'Cvx',
                                          accessor: 'cvx',
                                        },
                                        {
                                          Header: 'Name',
                                          accessor: 'name',
                                        },
                                        {
                                          Header: 'Description',
                                          accessor: 'description',
                                        },
                                        {
                                          Header: 'Administered Date',
                                          accessor: 'administeredDate',
                                          Cell: (row) => (
                                            <Moment
                                              date={
                                                row.original.administeredDate
                                              }
                                              format="MM/DD/YYYY"
                                            />
                                          ),
                                        },
                                        {
                                          Header: 'Qty',
                                          accessor: 'qty',
                                        },
                                        {
                                          Header: 'Qty Units',
                                          accessor: 'qtyUnits',
                                        },
                                        {
                                          Header: 'Lot Number',
                                          accessor: 'lotNumber',
                                        },
                                        {
                                          Header: 'Manufacturer Name',
                                          accessor: 'manufacturerName',
                                        },
                                        {
                                          Header: 'Reason',
                                          accessor: 'reason',
                                        },
                                        {
                                          Header: 'Expiration Date',
                                          id: 'expirationDate',
                                          accessor: (d) =>
                                            d.expirationDate && (
                                              <Moment
                                                date={d.expirationDate}
                                                format="MM/DD/YYYY hh:mm"
                                              />
                                            ),
                                        },
                                        {
                                          Header: 'Vis',
                                          accessor: 'vis',
                                        },
                                        {
                                          Header: 'Method',
                                          accessor: 'method',
                                        },
                                        {
                                          Header: 'Site',
                                          accessor: 'site',
                                        },
                                        {
                                          Header: 'Notes',
                                          accessor: 'notes',
                                        },
                                      ]}
                                      className="-striped -highlight"
                                      loading={isHealthProfileLoading}
                                      data={
                                        healthprofile[
                                          patient[0] &&
                                            patient[0].masterPatientId
                                        ].patientImmunization
                                          ? healthprofile[
                                              patient[0] &&
                                                patient[0].masterPatientId
                                            ].patientImmunization
                                          : []
                                      }
                                      minRows={2}
                                      sortable={true}
                                      defaultSorted={[
                                        {
                                          id: 'administeredDate',
                                          desc: true,
                                        },
                                        {
                                          id: 'name',
                                          asc: true,
                                        },
                                      ]}
                                      PaginationComponent={Pagination}
                                      showPaginationTop={false}
                                      pageSize={5}
                                      freezeWhenExpanded={true}
                                      filterable
                                      defaultFilterMethod={
                                        filterCaseInsensitive
                                      }
                                    />
                                  )}
                                  {/*
                                  <h4>Legal</h4>
																	<ul>
																		<li>Need to see fields</li>
                                  </ul>
                                  <h3>Health Maintenance</h3>
																	<ul>
																		<li>Need to see fields</li>
                                  </ul>
                                  */}
                                </div>
                              </div>
                            </div>
                            <div className="tab-pane fade" id="a2">
                              <ReactTable
                                columns={[
                                  {
                                    Header: 'Appointment Date',
                                    id: 'appointmentDate',
                                    accessor: (d) =>
                                      d.appointmentDate && (
                                        <Moment
                                          date={d.appointmentDate}
                                          format="MM/DD/YYYY hh:mm"
                                        />
                                      ),
                                  },
                                  {
                                    Header: 'Survey Date',
                                    id: 'date',
                                    accessor: (d) =>
                                      d.date && (
                                        <Moment
                                          date={d.date}
                                          format="MM/DD/YYYY hh:mm"
                                        />
                                      ),
                                  },
                                  {
                                    Header: 'NPS',
                                    accessor: 'nps',
                                  },
                                  {
                                    Header: 'NPS Reason',
                                    accessor: 'npsReason',
                                  },
                                  {
                                    Header: 'Site',
                                    accessor: 'site',
                                  },
                                ]}
                                className="-striped -highlight"
                                loading={data.isLoading}
                                data={
                                  data.surveyData ? data.surveyData.list : []
                                }
                                minRows={4}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'appointmentDate',
                                    desc: true,
                                  },
                                ]}
                                PaginationComponent={Pagination}
                                showPaginationTop={false}
                                pageSize={10}
                                freezeWhenExpanded={true}
                                filterable
                                defaultFilterMethod={filterCaseInsensitive}
                              />
                            </div>
                            <div className="tab-pane fade" id="a3">
                              <dl>
                                <dt>Hint Id:</dt>
                                <dd>{patient[0] && patient[0].hintId}</dd>
                                <dt>Hint Status:</dt>
                                <dd>{patient[0] && patient[0].hintStatus}</dd>
                                <dt>Hint Created Date:</dt>
                                <dd>
                                  {patient[0] && patient[0].hintCreatedDate && (
                                    <Moment
                                      date={
                                        patient[0] && patient[0].hintCreatedDate
                                      }
                                      format="MM/DD/YYYY"
                                    />
                                  )}
                                </dd>
                                <dt>Hint Cancelled Date:</dt>
                                <dd>
                                  {patient[0] &&
                                    patient[0].hintCancelledDate && (
                                      <Moment
                                        date={
                                          patient[0] &&
                                          patient[0].hintCancelledDate
                                        }
                                        format="MM/DD/YYYY"
                                      />
                                    )}
                                </dd>
                              </dl>
                            </div>
                            <div className="tab-pane fade" id="a4">
                              {/*<p>*/}
                              {/*  This section to contain communications (see*/}
                              {/*  "Send Message" link above) with patient.*/}
                              {/*</p>*/}
                              <br />
                              <button disabled={isExecutive}
                                className="btn btn-default"
                                onClick={this.showSpecialProgramModal.bind(this)}
                              >
                                <i className="fa fa-plus" /> Add Program
                              </button>
                              <br />
                              <br />
                              <dt>Special Programs</dt>
                              <Modal show={this.state.showModal}>
                                <Modal.Header>
                                  <button
                                    type="button"
                                    className="close"
                                    data-dismiss="modal"
                                    aria-hidden="true"
                                    onClick={this.closeSpecialProgramModal.bind(this)}
                                  >
                                    &times;
                                  </button>
                                  <h4 className="modal-title">Patient Special Programs</h4>
                                </Modal.Header>
                                <Modal.Body>
                                  <SpecialProgramForm onSubmit={this.onProgramSubmit} programOptions={data.specialPrograms}/>
                                </Modal.Body>
                              </Modal>
                             
                              <ReactTable
                                columns={[
                                  {
                                    Header: 'Actions',
                                    id: 'actions',
                                    width: 80,
                                    Cell: (row) => (
                                      <span>
                                        <button disabled={isExecutive}
                                          className="btn btn-primary btn-xs"
                                          onClick={() => this.unassignSpecialProgram(row.original.id)}
                                        >
                                          Remove
                                        </button>
                                      </span>
                                    ),
                                  },
                                  {
                                    Header: 'Id',
                                    accessor: 'id',
                                    show: false,
                                  },
                                  {
                                    Header: 'Program',
                                    accessor: 'program.name',
                                  },
                                  {
                                    Header: 'Assigned At',
                                    accessor: 'assignedAt',
                                    Cell: (row) => (
                                      <Moment
                                        date={row.original.assignedAt}
                                        format="MM/DD/YYYY HH:mm"
                                      />
                                    ),
                                  },
                                  {
                                    Header: 'Assigned By',
                                    accessor: 'assignedByEmail',
                                  },
                                  {
                                    Header: 'Assignment Type',
                                    accessor: 'assignmentType.name',
                                  },
                                ]}
                                className="-striped -highlight"
                                loading={data.ispatientSpecialProgramsLoading}
                                data={
                                  data.assignedSpecialPrograms
                                    ? data.assignedSpecialPrograms
                                    : []
                                }
                                minRows={4}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'id',
                                    desc: true,
                                  },
                                ]}
                                PaginationComponent={Pagination}
                                showPaginationTop={false}
                                pageSize={10}
                                freezeWhenExpanded={true}
                                defaultFilterMethod={filterCaseInsensitive}
                              />
                            </div>

                            <div className="tab-pane fade" id="a5">
                              <br />
                              <button disabled={isExecutive}
                                className="btn btn-default"
                                onClick={() =>
                                  this.showEscalationForm(
                                    0,
                                    this.props.params.masterPatientId,
                                  )
                                }
                              >
                                <i className="fa fa-plus" /> Add Escalation
                              </button>
                              <dl className="">
                                <br />
                                <dt>Escalation Details</dt>
                                <ReactTable
                                  ref={(instance) => {
                                    this.table = instance;
                                  }}
                                  pageSize={10}
                                  minRows={1}
                                  loading={escalations.isEscalationLoading}
                                  data={
                                    escalations &&
                                    escalations.data &&
                                    escalations.data.list
                                      ? escalations.data.list
                                      : []
                                  }
                                  columns={[
                                    {
                                      Header: '',
                                      id: 'actions',
                                      width: 55,
                                      sortable: false,
                                      Cell: (row) => (
                                        <span>
                                          <button disabled={isExecutive}
                                            className="btn btn-default btn-xs"
                                            onClick={() =>
                                              this.showEscalationForm(
                                                row.original.escalationId,
                                                this.props.params
                                                  .masterPatientId,
                                              )
                                            }
                                          >
                                            <i className="fa fa-pencil" />
                                          </button>
                                          &nbsp;
                                          <button disabled={isExecutive}
                                            className="btn btn-default btn-xs"
                                            onClick={() =>
                                              this.deleteEscalation(
                                                row.original.escalationId,
                                              )
                                            }
                                          >
                                            <i className="fa fa-trash" />
                                          </button>
                                        </span>
                                      ),
                                    },
                                    {
                                      Header: 'Escalation Id',
                                      id: 'escalationId',
                                      accessor: 'escalationId',
                                      show: false,
                                    },
                                    {
                                      Header: 'Date Reported',
                                      accessor: 'dateReported',
                                      Cell: (row) => (
                                        <Moment
                                          date={row.original.dateReported}
                                          format="MM/DD/YYYY HH:mm"
                                        />
                                      ),
                                    },
                                    {
                                      Header: 'Issue Name',
                                      accessor: 'issueName',
                                    },
                                    {
                                      Header: 'Issue Type',
                                      accessor: 'issueType',
                                    },
                                    {
                                      Header: 'Assigned To',
                                      accessor: 'assignedToName',
                                    },
                                    {
                                      Header: 'Description',
                                      accessor: 'description',
                                    },
                                    {
                                      Header: 'Resolved',
                                      accessor: 'resolved',
                                    },
                                  ]}
                                  className="-striped -highlight"
                                  onSearchChange={this.handleSearch}
                                />
                              </dl>
                            </div>

                            <div className="tab-pane fade" id="contacts">
                              <br />
                              <button disabled={isExecutive}
                                className="btn btn-default"
                                onClick={() =>
                                  this.showContactForm('00000000-0000-0000-0000-000000000000', 'Add', this.props.params.masterPatientId)
                                }
                              >
                                <i className="fa fa-plus" /> Add Contact
                              </button>
                              <br />
                              <ReactTable
                                ref={(instance) => {
                                  this.table = instance;
                                }}
                                pageSize={10}
                                minRows={1}
                                loading={contacts.isLoading}
                                data={contacts && contacts.data && contacts.data.list ? contacts.data.list : []
                                }
                                onFetchData={this.fetchData}
                                defaultSorted={[
                                  {
                                    id: 'contactName',
                                    desc: false,
                                  },
                                ]}
                                columns={[
                                  {
                                    Header: '',
                                    id: 'actions',
                                    width: 50,
                                    sortable: false,
                                    Cell: (row) => (
                                      <span>
                                        <button disabled={isExecutive}
                                          className="btn btn-default btn-xs"
                                          onClick={() =>
                                            this.showContactForm(
                                              row.original.contact.id, 'Edit', this.props.params.masterPatientId
                                            )
                                          }
                                        >
                                          <i className="fa fa-pencil" />
                                        </button>
                                      </span>
                                    ),
                                  },
                                  {
                                    Header: 'ID',
                                    id: 'id',
                                    accessor: 'id',
                                    show: false,
                                  },
                                  {
                                    Header: 'Contact',
                                    id: 'contact.contactName',
                                    accessor: 'contact.contactName',
                                    Cell: (row) => (
                                      <a
                                        onClick={() =>
                                          this.showContactForm(
                                            row.original.contact.id, 'ReadOnly', this.props.params.masterPatientId
                                          )
                                        }
                                      >
                                        {row.original.contact.contactName}
                                      </a>
                                    ),
                                  },
                                  {
                                    Header: 'Company',
                                    id: 'contact.company',
                                    accessor: 'contact.company',
                                  },
                                  {
                                    Header: 'Phone',
                                    id: 'contact.phone1',
                                    accessor: 'contact.phone1',
                                  },
                                  {
                                    Header: 'Email',
                                    id: 'contact.email1',
                                    accessor: 'contact.email1',
                                  },
                                  {
                                    Header: 'Website',
                                    id: 'contact.website',
                                    accessor: 'contact.website',
                                  },
                                  {
                                    Header: 'Description',
                                    id: 'contact.description',
                                    accessor: 'contact.description',
                                  },
                                ]}
                                className="-striped -highlight"
                                onSearchChange={this.handleSearch}
                              />
                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-12 col-lg-6">
                    <div className="padding-10">
                      <ul className="nav nav-tabs">
                        <li className="active">
                          <a href="#b1" data-toggle="tab">
                            All Activity
                          </a>
                        </li>
                        <li>
                          <a href="#b2" data-toggle="tab" aria-expanded="false">
                            <i className="fa fa-fw fa-lg fa-history hidden-xs" />{' '}
                            Encounters{' '}
                            {isEncountersLoading && (
                              <div className="spinner inline" />
                            )}
                            {encounters[
                              patient[0] && patient[0].masterPatientId
                            ] &&
                              encounters[
                                patient[0] && patient[0].masterPatientId
                              ].total > 0 &&
                              !isEncountersLoading && (
                                <span className="badge bg-color-blue txt-color-white">
                                  {
                                    encounters[
                                      patient[0] && patient[0].masterPatientId
                                    ].total
                                  }
                                </span>
                              )}
                          </a>
                        </li>
                        <li>
                          <a href="#b3" data-toggle="tab">
                            Claims
                            {data.isLoading && (
                              <div className="spinner inline" />
                            )}
                          </a>
                        </li>
                        <li>
                          <a href="#b4" data-toggle="tab">
                            Outreach
                            {outreach.isLoading && (
                              <div className="spinner inline" />
                            )}
                          </a>
                        </li>
                        <li>
                          <a href="#b6" data-toggle="tab">
                            Documents
                          </a>
                        </li>
                        <li>
                          <a
                            id="comments-tab-link"
                            href="#b5"
                            data-toggle="tab"
                          >
                            Comments
                            {comments.isLoading && (
                              <div className="spinner inline" />
                            )}
                          </a>
                        </li>
                      </ul>
                      <div className="tab-content padding-top-10">
                        <div className="tab-pane fade in active" id="b1">
                          {/*AllActivity Section*/}
                          <CommentForm isExecutive={isExecutive}
                            onSubmit={this.onSubmit}
                            parentId={null}
                          />
                          {data.isLoading && <div className="spinner" />}
                          <div style={{ overflow: 'auto', height: '800px' }}>
                            <AllActivity
                              activities={this.getActivityData(patient)}
                              onCommentClick={this.commentClick}
                            />
                          </div>
                        </div>

                        <div className="tab-pane fade" id="b2">
                          <ReactTable
                            columns={[
                              {
                                Header: '',
                                id: 'actions',
                                sortable: false,
                                width: 40,
                                Cell: (row) => (
                                  <span>
                                    <Link
                                      to={`/visit-note/${row.original.visitNoteID}`}
                                      target="_blank"
                                      className="btn btn-xs btn-default"
                                    >
                                      <i className="fa fa-external-link" />
                                    </Link>
                                  </span>
                                ),
                              },
                              {
                                Header: 'Visit Note Id',
                                accessor: 'visitNoteID',
                              },
                              {
                                Header: 'Elation Id',
                                accessor: 'patientID',
                              },
                              {
                                Header: 'Date of Service',
                                accessor: 'dateOfService',
                                Cell: (row) => (
                                  <Moment
                                    date={row.original.dateOfService}
                                    format="MM/DD/YYYY"
                                  />
                                ),
                              },
                              {
                                Header: 'Visit Reason',
                                accessor: 'visitReason',
                              },
                              {
                                Header: 'Practice Name',
                                accessor: 'practiceName',
                              },
                              {
                                Header: 'Employer Description',
                                accessor: 'employerDescription',
                              },
                            ]}
                            className="-striped -highlight"
                            loading={isEncountersLoading}
                            data={
                              encounters[
                                patient[0] && patient[0].masterPatientId
                              ] && !isEncountersLoading
                                ? encounters[
                                    patient[0] && patient[0].masterPatientId
                                  ].list
                                : []
                            }
                            minRows={4}
                            sortable={true}
                            defaultSorted={[
                              {
                                id: 'dateOfService',
                                desc: true,
                              },
                            ]}
                            PaginationComponent={Pagination}
                            showPaginationTop={false}
                            pageSize={10}
                            freezeWhenExpanded={true}
                            filterable
                            defaultFilterMethod={filterCaseInsensitive}
                          />
                        </div>

                        <div className="tab-pane fade" id="b3">
                          <div className="row">
                            <div className="col-md-12">
                              <h3>Medical Claims</h3>
                              <ReactTable
                                columns={[
                                  {
                                    Header: 'Date of Service',
                                    accessor: 'dateOfServiceStartDate',
                                    Cell: (row) => (
                                      <Moment
                                        date={
                                          row.original.dateOfServiceStartDate
                                        }
                                        format="MM/DD/YYYY"
                                      />
                                    ),
                                  },
                                  {
                                    Header: 'Place of Service',
                                    accessor: 'placeOfServiceGeneral',
                                  },
                                  {
                                    Header: 'Reason',
                                    accessor: 'primaryEDC',
                                  },
                                  {
                                    Header: 'Procedure',
                                    accessor: 'procedureName',
                                  },

                                  {
                                    Header: 'Carrier',
                                    accessor: 'carrierName',
                                  },
                                  {
                                    Header: 'Service Category',
                                    accessor: 'serviceTypeSubcat',
                                  },
                                ]}
                                className="-striped -highlight"
                                loading={data.isLoading}
                                data={
                                  data.medicalClaims
                                    ? data.medicalClaims.list
                                    : []
                                }
                                minRows={4}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'dateOfServiceStartDate',
                                    desc: true,
                                  },
                                ]}
                                PaginationComponent={Pagination}
                                showPaginationTop={false}
                                pageSize={10}
                                freezeWhenExpanded={true}
                                filterable
                                defaultFilterMethod={filterCaseInsensitive}
                              />
                            </div>
                          </div>
                          <div className="row">
                            <div className="col-md-12">
                              <h3>Rx Claims</h3>
                              <ReactTable
                                columns={[
                                  {
                                    Header: 'Name',
                                    accessor: 'drugName',
                                  },
                                  {
                                    Header: 'Plan Paid Amount',
                                    accessor: 'planPaidAmount',
                                  },
                                  {
                                    Header: 'Fill Date',
                                    accessor: 'filledAt',
                                    Cell: (row) => (
                                      <Moment
                                        date={row.original.filledAt}
                                        format="MM/DD/YYYY"
                                      />
                                    ),
                                  },
                                  {
                                    Header: 'Days Supply',
                                    accessor: 'daysSupply',
                                  },
                                ]}
                                className="-striped -highlight"
                                loading={data.isLoading}
                                data={data.rxClaims ? data.rxClaims.list : []}
                                minRows={4}
                                sortable={true}
                                defaultSorted={[
                                  {
                                    id: 'filledAt',
                                    desc: true,
                                  },
                                ]}
                                PaginationComponent={Pagination}
                                showPaginationTop={false}
                                pageSize={10}
                                freezeWhenExpanded={true}
                                filterable
                                defaultFilterMethod={filterCaseInsensitive}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="tab-pane fade" id="b4">
                          <div className="row">
                            <div className="col-md-12 col-sm-12 widget-toolbar">
                              <a disabled={isExecutive}
                                className="btn btn-primary"
                                onClick={() => this.getOutreach('00000000-0000-0000-0000-000000000000')}
                              >
                                <span className="hidden-xs">
                                  &nbsp;Add Outreach
                                </span>
                              </a>
                            </div>
                            <div className="col-sm-12">
                              <div className="table-responsive">
                                <table className="table table-bordered table-condensed">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Advocate Name</th>
                                      <th>Outreach Type</th>
                                      <th>Notes</th>
                                      <th>Next Follow-up</th>
                                      <th>Edit</th>
                                      <th>Delete</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {outreaches && outreaches.list && outreaches.list.map(outreach => (
                                      <tr key={outreach.id}>
                                        <td>
                                          <Moment
                                            date={outreach.date}
                                            format="MM/DD/YYYY"
                                          />
                                        </td>
                                        <td>{outreach.createdByName}</td>
                                        <td>{outreach.typeName}</td>
                                        <td>{outreach.note}</td>
                                        <td>
                                          {outreach.nextFlowUpAt !== null && (
                                            <Moment
                                              date={outreach.nextFlowUpAt}
                                              format="MM/DD/YYYY"
                                            />
                                          )}
                                        </td>
                                        <td>
                                          <button className="btn btn-default btn-xs"
                                            onClick={() => this.getOutreach(outreach.id)}>
                                            <i className="fa fa-pencil" />
                                          </button>
                                        </td>
                                        <td>
                                          <button className="btn btn-default btn-xs"
                                            onClick={() => this.deleteOutreach(outreach.id)}>
                                            <i className="fa fa-trash" />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                        <Modal show={this.state.showOutreachModal}>
                          <Modal.Header>
                            <button
                              type="button"
                              className="close"
                              data-dismiss="modal"
                              aria-hidden="true"
                              onClick={this.closeModal.bind(this)}
                            >
                              &times;
                            </button>
                            <h4 className="modal-title">Add/Edit Outreach</h4>
                          </Modal.Header>
                          <Modal.Body>
                            <OutreachEditForm
                              masterPatientId={patient[0] && patient[0].masterPatientId}
                              onCancel={this.closeModal.bind(this)}
                              onSave={this.closeModal.bind(this)}
                              onSubmit={this.updateOutreach}
                              searchOutreachTypes={this.searchOutreachTypes}
                            />
                          </Modal.Body>
                        </Modal>
                        <div className="tab-pane fade" id="b6">
                          <div className="col-md-12">
                            <ReactTable
                              columns={[
                                {
                                  Header: 'Name',
                                  accessor: 'name',
                                  filterable: true,
                                  Cell: (row) => (
                                    <a
                                      onClick={() =>
                                        this.previewFile(row.original.patientId,
                                          row.original.id, row.original.fileName)
                                      }
                                    >
                                      {row.original.name}
                                    </a>
                                  ),
                                },
                                {
                                  Header: 'Source',
                                  accessor: 'source',
                                  filterable: true,
                                },
                                {
                                  Header: 'Date',
                                  accessor: 'date',
                                  filterable: true,
                                  Cell: (row) => (
                                    <Moment
                                      date={row.original.date}
                                      format="MM/DD/YYYY"
                                    />
                                  ),
                                },
                                {
                                  Header: 'Send',
                                  accessor: 'send',
                                  width: 60,
                                  Cell: ({ value }) =>
                                    <div style={{ textAlign: "center" }} >
                                      <input type="checkbox" value={value} />
                                    </div>
                                },
                                {
                                  Header: 'Remove',
                                  accessor: 'remove',
                                  width: 60,
                                  Cell: (row) => (
                                    <div style={{ textAlign: "center" }} >
                                      <button className="btn btn-default btn-xs"
                                        onClick={() => this.deleteDocument(row.original.patientId, row.original.id)}>
                                        <i className="fa fa-trash" />
                                      </button>
                                    </div>
                                  ),
                                },
                              ]}
                              className="-striped -highlight"
                              minRows={5}
                              sortable={true}
                              PaginationComponent={Pagination}
                              showPaginationTop={false}
                              loading={isDocumentsLoading}
                              data={documents && documents.data ? documents.data : []}
                              pageSize={5}
                              freezeWhenExpanded={true}
                              defaultFilterMethod={
                                filterCaseInsensitive
                              }
                            />
                          </div>
                          <br />
                          <div>
                            <h4>
                              <span className="semi-bold">
                              Do not see what you are looking for?
                              </span>
                            </h4>
                          </div>
                          <br />
                          <div className="row">
                            <div className="col-md-8">
                            <h4>
                              <span className="semi-bold">
                                Upload from your local computer:
                              </span>&nbsp;&nbsp;
                              </h4>
                            </div>
                            <div className="col-md-3 text-right">
                              <button
                                className="btn btn-primary btn-xs"
                                onClick={() => this.showUploadModal()}
                              >
                                Upload
                              </button>
                            </div>
                            <div className="col-md-1">
                            </div>
                          </div>
                          <br />
                          <div className="row">
                            <div className="col-md-8">
                              <h4>
                                <span className="semi-bold">
                                  Query network of community {/*providers via QUIN (Kno2):*/}
                                </span>

                                <br />
                                <span className="semi-bold">
                                  {/*Query network of community*/} providers via QUIN (Kno2):
                                </span>
                                &nbsp;&nbsp;
                              </h4>
                            </div>
                            <Modal
                              show={this.state.showPreview}
                              dialogClassName="modal-lg"
                            >
                              <Modal.Header>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-hidden="true"
                                  onClick={this.closePreview.bind(this)}
                                >
                                  &times;
                                </button>
                                <h4 className="modal-title">File Viewer</h4>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="widget-body">
                                  {
                                    <FileViewer
                                      fileType={this.state.fileType}
                                      filePath={this.state.fileName}
                                    />
                                  }
                                </div>
                              </Modal.Body>
                            </Modal>

                            <Modal show={this.state.showUpload}>
                              <Modal.Header>
                                <button
                                  type="button"
                                  className="close"
                                  data-dismiss="modal"
                                  aria-hidden="true"
                                  onClick={this.closeUploadModal.bind(this)}
                                >
                                  &times;
                                </button>
                                <h4 className="modal-title" id="addFilesModalLabel">
                                  Add Files
                                </h4>
                              </Modal.Header>
                              <Modal.Body>
                                <div className="row client-files-upload">
                                  <div
                                    className={
                                      this.state.files.length > 0
                                        ? 'col-sm-12'
                                        : 'col-sm-12'
                                    }
                                  >
                                    <Dropzone
                                      accept={acceptedFiles}
                                      onDrop={this.onDrop.bind(this)}
                                      onFileDialogCancel={this.onFileCancel.bind(this)}
                                    >
                                      {({
                                        getRootProps,
                                        getInputProps,
                                        isDragActive,
                                      }) => {
                                        return (
                                          <div
                                            {...getRootProps()}
                                            className={classNames(
                                              'dropzone dropzone-client-files',
                                              { 'dropzone--isActive': isDragActive },
                                            )}
                                          >
                                            <input {...getInputProps()} />
                                            {isDragActive ? (
                                              <p>Drop files here...</p>
                                            ) : (
                                              <span className="text-center">
                                                <span className="font-lg visible-xs-block visible-sm-block visible-lg-block">
                                                  <span className="font-lg">
                                                    Drop files{' '}
                                                    <span className="font-xs">
                                                      to upload
                                                    </span>
                                                  </span>
                                                  <span>
                                                    &nbsp;&nbsp;
                                                    <h4 className="display-inline">
                                                      {' '}
                                                      (Or Click)
                                                    </h4>
                                                  </span>
                                                </span>
                                              </span>
                                            )}
                                          </div>
                                        );
                                      }}
                                    </Dropzone>
                                  </div>
                                  {this.state.files.length > 0 && (
                                    <div className="col-sm-12">
                                      <h4>Files to be uploaded</h4>
                                      <ul className="list-group files-upload-list">
                                        {filesToUpload}
                                      </ul>
                                      {` `}
                                      {this.state.files.length === 1 && (
                                        <h6 className="txt-color-red">Only one file per request accepted.</h6>
                                      )}
                                      {/* {this.state.files.length > 0 && <button className="btn btn-default" onClick={this.onCancel.bind(this)}>Clear</button>}{` `} */}
                                    </div>
                                  )}
                                </div>
                              </Modal.Body>
                              <Modal.Footer>
                                <button
                                  type="button"
                                  className="btn btn-default"
                                  data-dismiss="modal"
                                  onClick={this.closeUploadModal.bind(this)}
                                  disabled={isFilesUploading}
                                >
                                  Cancel
                                </button>
                                <button
                                  type="button"
                                  className="btn btn-primary"
                                  disabled={this.state.files.length === 0}
                                  onClick={this.onStartUpload.bind(this)}
                                >
                                  Upload Files
                                </button>
                              </Modal.Footer>
                              {isFilesUploading && (
                                <div className="cover">
                                  <div className="spinner" />
                                </div>
                              )}
                            </Modal>
                            <div className="col-md-3 text-right">
                              <button
                                className="btn btn-primary btn-xs"
                                onClick={() => this.queryKno2()}
                              >
                                Query Kno2
                              </button>
                            </div>
                            <div className="col-md-1">
                            </div>
                          </div>
                          {(this.state.showKno2Orgs) && (
                            <PatientQueryKno2 queryKno2={this.fetchQueryKno2()} />
                          )}
                        </div>
                        
                        <div className="tab-pane fade" id="b5">
                          <div className="col-md-12 col-sm-12 col-xs-12 ">
                            {/*Comments Section*/}
                            <CommentForm isExecutive={isExecutive}
                              onSubmit={this.onSubmit}
                              parentId={null}
                            />
                            {comments.isLoading && <div className="spinner" />}
                            <Comments isExecutive={isExecutive}
                              comments={
                                comments && comments.data && comments.data.list
                                  ? comments.data.list
                                  : []
                              }
                              userid={user.data.id}
                              onUpdateSubmit={this.onUpdateSubmit}
                              onDeleteSubmit={this.onDeleteSubmit}
                              onSubmit={this.onSubmit}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </WidgetGrid>
      </div>
    );
  }
}

export default connect(
  (state) => ({
    ...state.visitNotes,
    data: state.patients,
    history: state.patients.history,
    isHistoryLoading: state.patients.isHistoryLoading,
    healthprofile: state.patients.healthprofile,
    isHealthProfileLoading: state.patients.isHealthProfileLoading,
    encounters: state.patients.encounters,
    isEncountersLoading: state.patients.isEncountersLoading,
    documents: state.patients.documents,
    isDocumentsLoading: state.patients.isDocumentsLoading,
    comments: state.comments,
    user: state.currentUser,
    escalations: state.escalationmanager,
    contacts: state.contactmanager,
    isSuperAdmin: isSuperAdmin(state),
    isMakoAdmin: isMakoAdmin(state),
    isMakoUser: isMakoUser(state),
    isExecutive: isExecutive(state),
    tenantId: state.currentUser.queryParams.tenantId,
    outreach: state.outreach,
    queryKno2: state.queryKno2,
  }),
  (dispatch) => ({
    getPatient: (masterPatientId, params) =>
      dispatch(requestPatient(masterPatientId, params)),
    getPatientComments: (masterPatientId, params) =>
      dispatch(requestPatientComments(masterPatientId, params)),
    addMessage: (message, params) =>
      dispatch(addPatientComment(message, params)),
    updateMessage: (id, message, params) =>
      dispatch(updatePatientComment(id, message, params)),
    deleteMessage: (id, params) => dispatch(deletePatientComment(id, params)),
    getEncounters: (patientId, visitNoteId, params) =>
      dispatch(requestPatientEncounters(patientId, visitNoteId, params)),
    getMedicalClaims: (patientId, params) =>
      dispatch(requestMedicalClaims(patientId, params)),
    getRxClaims: (patientId, params) =>
      dispatch(requestRxClaims(patientId, params)),
    getHistory: (patientId, params) =>
      dispatch(requestClaimsHistory(patientId, params)),
    getCurrentUser: () => dispatch(requestUserInfo()),
    getHealthProfile: (patientId, params) =>
      dispatch(requestHealthProfile(patientId, params)),
    getSurveyData: (patientId, params) =>
      dispatch(requestSurveyData(patientId, params)),
    getEscalations: (masterPatientId, params) =>
      dispatch(requestPatientEscalations(masterPatientId, params)),
    deletePatientEscalation: (escalationId, params) =>
      dispatch(deletePatientEscalation(escalationId, params)),
    invitePatient: (patientId, params) =>
      dispatch(requestInvitePatient(patientId, params)),
    getContacts: (masterPatientId, params) =>
      dispatch(requestPatientContacts(masterPatientId, params)),
    getAllSpecialPrograms: (params) =>
      dispatch(requestAllSpecialPrograms(params)),
    getPatientSpecialProgramsByPatientId: (masterPatientId, params) =>
      dispatch(requestPatientSpecialProgramsByPatientId(masterPatientId, params)),
    getAssignedPatientSpecialProgramsByPatientId: (masterPatientId, params) =>
      dispatch(requestAssignedPatientSpecialProgramsByPatientId(masterPatientId, params)),
    updateSpecialProgram: (patientId, specialProgramId, params) =>
      dispatch(updatePatientToSpecialProgram(patientId, specialProgramId, params)),
    unassignPatientSpecialProgram: (id, params) =>
      dispatch(unassignPatientSpecialProgram(id, params)),
    getOutreach: (id, params) => dispatch(requestOutreachDetails(id, params)),
    getOutreaches: (params) => dispatch(requestOutreaches(params)),
    getOutreachTypes: (params) => dispatch(requestOutreachTypes(params)),
    updateOutreach: (task, params) => dispatch(updateOutreach(task, params)),
    deleteOutreach: (id, params) => dispatch(deleteOutreach(id, params)),
    getKno2PatientDiscovery: (params) =>
      dispatch(requestKno2PatientDiscovery(params)),
    getPatientDocuments: (masterPatientId, params) => dispatch(requestPatientDocuments(masterPatientId, params)),
    previewPatientDocumentFile: (masterPatientId, documentId, params, fileName) =>
      dispatch(previewPatientDocumentFile(masterPatientId, documentId, params, fileName)),
    uploadFiles: (masterPatientId, params, files) => dispatch(uploadPatientDocuments(masterPatientId, params, files)),
    deletePatientDocument: (patientId, documentId, params) => dispatch(deletePatientDocument(patientId, documentId, params))
  }),
)(PatientProfile);



// WEBPACK FOOTER //
// ./src/routes/management/containers/PatientProfile.js